import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, ChapterLabel } from "./Reveal";
import { site } from "../content";

export const Faq = () => {
  const { faq } = site;
  return (
    <section id="ukk" className="py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <ChapterLabel chapter={faq.chapter} label={faq.label} />
          <h2 className="mt-5 font-serif font-light text-3xl md:text-5xl tracking-tight text-[#2B2724]">
            {faq.title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#5C564F] max-w-xl">{faq.lead}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12">
            {faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`q-${i}`}
                className="border-b border-[#EFE6DC]"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger
                  className="py-6 font-serif text-xl md:text-2xl font-normal text-[#2B2724] hover:text-[#4A6572] hover:no-underline transition-colors duration-200 gap-4"
                  data-testid={`faq-question-${i + 1}`}
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  className="pb-7 text-base leading-relaxed text-[#5C564F] max-w-2xl"
                  data-testid={`faq-answer-${i + 1}`}
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
